class CookieBannerNonBlocking {
  constructor() {
    this.init();
  }

  init() {
    // Wait for cookie banner to exist in DOM
    this.waitForBanner();
  }

  waitForBanner() {
    const banner = document.querySelector('cookie-banner');
    if (banner) {
      this.makeNonBlocking(banner);
      
      // Watch for when banner opens
      const observer = new MutationObserver(() => {
        this.makeNonBlocking(banner);
      });
      
      observer.observe(banner, { 
        attributes: true, 
        attributeFilter: ['hidden'] 
      });
    } else {
      setTimeout(() => this.waitForBanner(), 100);
    }
  }

  makeNonBlocking(banner) {
    // Find the overlay element
    const overlay = banner.querySelector('overlay-element');
    if (overlay) {
      // Make overlay non-blocking
      overlay.style.pointerEvents = 'none';
      overlay.style.display = 'none';
    }

    // Find the drawer inner
    const drawerInner = banner.querySelector('.drawer__inner');
    if (drawerInner) {
      // Remove positioning that blocks content
      drawerInner.style.position = 'fixed';
      drawerInner.style.bottom = '0';
      drawerInner.style.left = '0';
      drawerInner.style.right = 'auto';
      drawerInner.style.top = 'auto';
      drawerInner.style.width = 'auto';
      drawerInner.style.maxWidth = '500px';
      drawerInner.style.height = 'auto';
      drawerInner.style.pointerEvents = 'auto';
      drawerInner.style.margin = '20px';
      drawerInner.style.borderRadius = '8px';
      drawerInner.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)';
      
      // Add smooth animation
      drawerInner.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
    }

    // Make the cookie-banner itself non-blocking
    banner.style.pointerEvents = 'none';
    
    // But keep the content clickable
    const content = banner.querySelector('.drawer__content');
    if (content) {
      content.style.pointerEvents = 'auto';
    }

    // Add a close button functionality
    this.enhanceCloseButton(banner);
  }

  enhanceCloseButton(banner) {
    // Find all buttons in the cookie banner
    const buttons = banner.querySelectorAll('button');
    
    buttons.forEach(button => {
      // Add a visual close animation when clicked
      button.addEventListener('click', () => {
        const drawerInner = banner.querySelector('.drawer__inner');
        if (drawerInner) {
          drawerInner.style.transform = 'translateY(100%)';
          drawerInner.style.opacity = '0';
          
          setTimeout(() => {
            banner.hidden = true;
          }, 300);
        }
      });
    });
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CookieBannerNonBlocking());
} else {
  new CookieBannerNonBlocking();
}